import { render, staticRenderFns } from "./OpenBatchForm.vue?vue&type=template&id=13b78f42&scoped=true&"
import script from "./OpenBatchForm.vue?vue&type=script&lang=js&"
export * from "./OpenBatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b78f42",
  null
  
)

export default component.exports